/**
 * Keyboard Hanldler
 */
const Keyboard = {
  /**
   * The Keyboard Events
   */
  eventList: [],
  /**
   * Add a `keyup` event to the queue
   *
   * @param {String} key the key code
   * @param {Function} callback The function to trigger
   */
  up(key, callback = () => {}) {
    this.eventList.push({
      key,
      type: 'up',
      callback,
    })
  },
  /**
   * Add a `keydown` event to the queue
   *
   * @param {String} key the key code
   * @param {Function} callback The function to trigger
   */
  down(key, callback = () => {}) {
    this.eventList.push({
      key,
      type: 'down',
      callback,
    })
  },
}

/**
 * Trigguers all the `keyup` events saved into the Keyboard Object
 */
window.addEventListener('keyup', e => {
  const { key, code } = e

  const eventsToFire = Keyboard.eventList.filter(
    event => event.type === 'up' && (event.key === key || event.key === code)
  )

  if (eventsToFire.length) {
    eventsToFire.forEach(event => {
      event.callback(e)
    })
  }
})

/**
 * Trigguers all the `keydown` events saved into the Keyboard Object
 */
window.addEventListener('keydown', e => {
  const { key, code } = e

  const eventsToFire = Keyboard.eventList.filter(
    event => event.type === 'down' && (event.key === key || event.key === code)
  )

  if (eventsToFire.length) {
    eventsToFire.forEach(event => {
      event.callback(e)
    })
  }
})

export default Keyboard
